/* istanbul ignore file */

const infoCircleYellow = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Warning</title>
    <g clipPath="url(#clip0_16479_36200)">
      <path
        d="M12 24C18.6272 24 24 18.6272 24 12C24 5.3728 18.6272 -1.90735e-06 12 -1.90735e-06C5.3728 -1.90735e-06 -1.90735e-06 5.3728 -1.90735e-06 12C-1.90735e-06 18.6272 5.3728 24 12 24ZM10.5 4.5H13.5V13.5H10.5V4.5ZM12 15.9C12.5304 15.9 13.0391 16.1107 13.4142 16.4858C13.7893 16.8609 14 17.3696 14 17.9C14 18.4304 13.7893 18.9391 13.4142 19.3142C13.0391 19.6893 12.5304 19.9 12 19.9C11.4696 19.9 10.9609 19.6893 10.5858 19.3142C10.2107 18.9391 10 18.4304 10 17.9C10 17.3696 10.2107 16.8609 10.5858 16.4858C10.9609 16.1107 11.4696 15.9 12 15.9Z"
        fill="#CE801A"
      />
    </g>
    <defs>
      <clipPath id="clip0_16479_36200">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default infoCircleYellow;
